import i18n from "../i18n";
import { moduleSettings } from "../stores/module-settings.store";
import { getLanguageSwitcherService } from "./language-switcher.service";
import { requestParamsImpl } from "./request-params.service";

const localStorageKeys = {
  preferredLanguage: "329491-hnbvch-sa7rf8-ans75j-3mc8hs-language",
  selection: "snhudo-sadnh2-3897hb-u9ochn-02879f-selection",
};

class LocalStorageService {
  public initLocalLanguage(defaultLocale: string) {
    const availables_locales =
      moduleSettings?.settings.available_locales || i18n.options.supportedLngs;

    const _navigatorLanguage = availables_locales.includes(
      navigator.language.slice(0, 2)
    )
      ? navigator.language.slice(0, 2)
      : "";
    i18n.changeLanguage(
      getLanguageSwitcherService().localeForCountryCode(
        this.preferredLanguageCookie || _navigatorLanguage || defaultLocale
      )
    );
  }

  //!\if a preferredLanguageCookie is present
  //the restaurantLocale will get overwritten
  setDefaultLocalLanguage() {
    const overwrittenLocale: string | undefined =
      requestParamsImpl.overwrittenLocale();
    const countries = getLanguageSwitcherService().switcherData(
      i18n.options.supportedLngs!
    );
    overwrittenLocale &&
    countries.includes(
      getLanguageSwitcherService().countryCodeForLocale(overwrittenLocale)
    )
      ? i18n.changeLanguage(overwrittenLocale!)
      : this.initLocalLanguage(moduleSettings.getDefaultLocale());
  }

  public get preferredLanguageCookie(): string {
    try {
      return (
        localStorage
          .getItem(localStorageKeys.preferredLanguage)
          ?.toLowerCase() || ""
      );
    } catch (error) {
      return "";
    }
  }

  public set preferredLanguageCookie(value: string) {
    try {
      localStorage.setItem(localStorageKeys.preferredLanguage, value);
    } catch {}
  }
}

let localStorageService: LocalStorageService;

export const getLocalStorageService = (): LocalStorageService => {
  if (!localStorageService) {
    localStorageService = new LocalStorageService();
  }
  return localStorageService;
};
